<template>
  <div></div>
</template>

<script>
export default {
  name: "camera-options-data",
  components: {},
  props: {},
  data() {
    return {}
  },
  comments: {},
  mounted() {},
  computed: {},
  methods: {}
}
</script>

<style scoped>
.left-label {
  min-width: 60px;
}
.card {
  background: rgba(41, 44, 49, 1);
}
.count-limit-item/deep/ .el-input__inner {
  background: #35383f;
  padding: 0 12px;
  border-radius: 4px;
}

.setting-item .count-limit-item span {
  margin: 0 8px;
}
.setting-item .content-item .el-checkbox {
  margin-right: 20px;
}
.count-limit-item /deep/ .el-radio {
  margin-top: 7px;
  margin-bottom: 3px;
}

.count-limit-item /deep/ .el-radio:first-child {
  margin-top: 0;
}

.count-limit-item /deep/ .el-radio-group {
  width: 80px;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 70px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dataSource-item .link {
  color: var(--themeColor);
  cursor: pointer;
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--thirdTextColor);
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px;
}
.edit-div:focus {
  outline: none;
  border: 1px solid var(--themeColor);
}
</style>
